/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * NEXMAIL (Internal)
 * Internal API consumed by the nexmail dashboard.
 * OpenAPI spec version: 0.0.1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type { SystemBrandDefaultsResponseDto } from '.././models';

import { authFetch } from '../../../../lib/api';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * @summary Get the system brand defaults (fallback config)
 */
export const systemBrandDefaultsControllerGet = (
  options?: SecondParameter<typeof authFetch>,
  signal?: AbortSignal
) => {
  return authFetch<SystemBrandDefaultsResponseDto>(
    { url: `/api/v1/system-brand-defaults`, method: 'GET', signal },
    options
  );
};

export const getSystemBrandDefaultsControllerGetQueryKey = () => {
  return [`/api/v1/system-brand-defaults`] as const;
};

export const getSystemBrandDefaultsControllerGetQueryOptions = <
  TData = Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
  TError = unknown,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>, TError, TData>
  >;
  request?: SecondParameter<typeof authFetch>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getSystemBrandDefaultsControllerGetQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>> = ({
    signal,
  }) => systemBrandDefaultsControllerGet(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type SystemBrandDefaultsControllerGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>
>;
export type SystemBrandDefaultsControllerGetQueryError = unknown;

export function useSystemBrandDefaultsControllerGet<
  TData = Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
  TError = unknown,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSystemBrandDefaultsControllerGet<
  TData = Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
          TError,
          Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useSystemBrandDefaultsControllerGet<
  TData = Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get the system brand defaults (fallback config)
 */

export function useSystemBrandDefaultsControllerGet<
  TData = Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>,
  TError = unknown,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof systemBrandDefaultsControllerGet>>, TError, TData>
    >;
    request?: SecondParameter<typeof authFetch>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getSystemBrandDefaultsControllerGetQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
